module.exports = __webpack_public_path__ + "img/manual.2992d2f5.png";